import { ConfigInterface } from 'swr';
import { wpAcfV3Api, useWPAcfV3Api, parseUrl } from '@gik/core/api';
import { IWordpressPageNameSuggestion } from '@gik/core/models/wordpress/WordpressSituation';

const path = 'options/options/page_name_suggestions';

export interface IGeneralPageNameSuggestionsResponse {
  page_name_suggestions: IWordpressPageNameSuggestion[];
}

export function getGeneralPageNameSuggestions() {
  const finalUrl = parseUrl(path, {});
  return wpAcfV3Api.get(finalUrl);
}

export function useGeneralPageNameSuggestions(config?: ConfigInterface) {
  return useWPAcfV3Api<IGeneralPageNameSuggestionsResponse>(path, config, {});
}
